import { render, staticRenderFns } from "./Profile-Password.vue?vue&type=template&id=638fa366&scoped=true&"
import script from "./Profile-Password.vue?vue&type=script&lang=js&"
export * from "./Profile-Password.vue?vue&type=script&lang=js&"
import style0 from "./Profile-Password.vue?vue&type=style&index=0&id=638fa366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638fa366",
  null
  
)

export default component.exports